import React from "react"
import DodonesListItem from 'app/dodones/list/Item'

export default ({ dodones }) => {
  return <div className="fcol flex-1">
           <div className="fcol flex-1" style={{ overflowY: 'scroll' }}>
             {
               dodones.map((dodone) => {
                 return <DodonesListItem key={ dodone.id } dodone={ dodone } />
               })
             }
           </div>
         </div>;
};
